import type { LineStyleT } from '../constants/relationship-renderer';
export type EdgeDataT = {
  id: string;
  sourceCenter: [number, number];
  targetCenter: [number, number];
  names: string[];
  color: string;
  textColor?: string;
  directed: boolean;
  lineStyle: LineStyleT;
};